@if (listingAsPages?.models) {
@if (component?.heading) {
<div class="center wrap">
    <h2 class="m-t-3 p-b-7 p-b-10-s"
        [ngClass]="[component.color || 'col-11', component.text_style || 'h2']"
        *iCms="'heading' of component"></h2>
</div>
}
@if (listing && tags?.length) {
<div class="center">
    <div class="drag-links"
         dragScroll>
        @for (filter of listing.filters; track filter.id) {
        @if (filter.id === 'primary-tag') {
        <filter-primary-tag class="inline-block m-l-3-s"
                            [filter]="$any(filter)" />
        @for (tag of tags; track $index) {
        <filter-primary-tag class="inline-block"
                            [class.m-r]="$last"
                            [filter]="$any(filter)"
                            [primaryTag]="tag" />
        }
        }
        }
    </div>
</div>
}
<div class="center wrap-x p-b listing-component"
     (infiniteScroll)="listing.increaseLimit()"
     [infinitScrollActive]="listing.getLimit() < listing.getTotal()">
    <div class="w-10-x w-10-l w-12 left">
        <!-- Hero post enabled -->
        @for (group of listingAsBlogPosts?.models | partition : (component.hero_posts ? 3 : 2) : true; track $index; let
        isEven = $even; let isOdd = $odd; let firstBlock = $first) {
        <div [ngClass]="firstBlock ? 'm-t-8' : 'm-t-10'"
             [grid]="client.isS ? 1 : 10"
             [gridColumnGap]="0"
             [gridRowGap]="client.isS ? 16 : 10">
            @for (model of group; track model.id; let isFirst = $first; let isLast = $last) {
            @if (component.hero_posts) {
            @if ((isEven && isFirst) || (isOdd && isLast && !client.isS) || (isOdd && isFirst && client.isS)) {
            <!-- hero post -->
            <div class="flex"
                 [ngClass]="isEven ? 'p-l p-r-4-s m-r--2 m-r-0-s' : 'p-r-1 p-l-1 p-r-4-s p-l-4-s'"
                 [gridColumn]="client.isS ? 0 : 5"
                 [gridRowSpan]="client.isS ? 1 : 2"
                 [gridColumnOffset]="isOdd ? client.isS ? 0 : 5 : 0"
                 [gridColumnPushRight]="isOdd ? 1 : 0">
                <div class="pos-relative w-12 flex-grow">
                    <href [link]="model.data.url">
                        <div class="pos-relative z-2 w-12">
                            <img class="w-12"
                                 [dfImage]="model?.data?.typeData?.image || model.data.image"
                                 ratio="2/3">
                            <div class="m-t pos-absolute bg-col-6 top-6-x top-6-l top-6-m bottom-6-s w-7 w-9-s p-a-2 p-b-5 p-l-8"
                                 [ngClass]="(isOdd && !client.isS)  ? 'right right-0' : ''"
                                 style="min-height: 8.75rem;">
                                <!-- date -->
                                @if (model.data.typeData.date) {
                                <p class="m-t-1 o1">
                                    {{model.data.typeData.date | date: 'dd' | ordinal}}
                                    {{model.data.typeData.date | date: 'MMMM yyyy'}}</p>
                                }
                                <!-- title -->
                                <h1 class="m-t-2 m-t-1-s h3">
                                    {{model.data?.typeData?.title || model.data.name}}
                                </h1>
                                <!-- button -->
                                <action class="m-t-1 m-t-4-s button-inline">
                                    {{component.cta_copy}}
                                </action>
                            </div>
                        </div>
                    </href>
                </div>
            </div>
            } @else {
            <!-- standard posts -->
            <div class="wrap-s"
                 [ngClass]="isEven ? 'm-l-1 p-l-10 p-r-1' : 'p-l p-r-8'"
                 [gridColumn]="5"
                 [gridColumnOffset]="isEven ? client.isS ? 0 : 5 : 0">
                <href [link]="model.data.url">
                    <div class="w-12">
                        <img class="w-12"
                             [dfImage]="model.data?.typeData?.image"
                             ratio="3/2">
                        <div class="m-t-2 m-t-3-s p-b-4-s">
                            <!-- date -->
                            @if (model.data.typeData.date) {
                            <p class="c1 uppercase">
                                {{model.data.typeData.date | date: 'dd' | ordinal}}
                                {{model.data.typeData.date | date: 'MMMM yyyy'}}</p>
                            }
                            <!-- title -->
                            <h2 class="m-t-1 h3">
                                {{model.data?.typeData?.title || model.data.name}}
                            </h2>
                            <!-- read more button -->
                            <action class="m-t-1 m-t-4-s button-inline">
                                {{component.cta_copy}}
                            </action>
                        </div>
                    </div>
                </href>
            </div>
            }
            } @else {
            <!-- standard posts -->
            <div class="wrap-s p-l p-r"
                 [gridColumn]="5">
                <href [link]="model.data.url">
                    <div class="w-12">
                        <img class="w-12"
                             [dfImage]="model.data?.typeData?.image"
                             ratio="3/2">
                        <div class="m-t-2 m-t-3-s p-b-4-s">
                            <!-- date -->
                            @if (model.data.typeData.date) {
                            <p class="c1 uppercase">
                                {{model.data.createdAt | date: 'dd' | ordinal}}
                                {{model.data.createdAt | date: 'MMMM yyyy'}}</p>
                            }
                            <!-- title -->
                            <h2 class="m-t-1 h3">
                                {{model.data?.typeData?.title || model.data.name}}
                            </h2>
                            <!-- read more button -->
                            <action class="m-t-1 m-t-4-s button-inline">
                                {{component.cta_copy}}
                            </action>
                        </div>
                    </div>
                </href>
            </div>
            }
            }
        </div>
        }
    </div>
</div>
@if (listing?.hasMore) {
<div class="center m-t-4-s">
    <button class="button p-a-3 p-a-6-s m-b-8-s m-b-10"
            (click)="showMore()">
        @if (!client.isS) {
        <span>{{'View more stories' | translate}}</span>
        } @else {
        <span>{{'View more' | translate}}</span>
        }
    </button>
</div>
}
} @else {
<p class="p-t p-b center">{{'No posts to display' | translate}}</p>
}